export default __webpack_public_path__ + "static/logo-16a6930c65108a023f687b08ad2ce4ac.png";